<app-configuration-page
  title="Import Student Accounts"
  description="Bring student accounts into the studio from a spreadsheet."
  [breadcrumbs]="[{ label: 'Simple Import' }, { label: 'Import Student Accounts' }]">

  <app-simple-import-student-accounts></app-simple-import-student-accounts>

</app-configuration-page>
